/**
 * The hub's enabled-extension list (GET /extensions, admin-only) as ONE
 * react-query entry shared by the sidebar and the extension route (HUB-103).
 */
import { useQuery } from '@tanstack/react-query';
import { hub } from '@/lib/hub-client';

export const EXTENSIONS_QUERY_KEY = ['extensions'] as const;

export type EnabledExtension = Awaited<ReturnType<typeof hub.extensionsList>>['extensions'][number];

export function useEnabledExtensions(enabled = true) {
  return useQuery({
    queryKey: EXTENSIONS_QUERY_KEY,
    queryFn: async () => (await hub.extensionsList()).extensions,
    enabled,
    staleTime: 5 * 60_000,
  });
}
